import { render, staticRenderFns } from "./mon.vue?vue&type=template&id=20db6e7b&"
import script from "./mon.vue?vue&type=script&lang=js&"
export * from "./mon.vue?vue&type=script&lang=js&"
import style0 from "./mon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports